import React from 'react'
import { Transaction } from '@web/walter-lib/stream/types'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import TxNotificationIcon from '../../TxNotificationIcon'
import AmountContent from '../AmountContent'
import { getErrorNotification } from '../notifications'
import { ProcessedNotificationData } from '../types'
import { lang } from './lang'
import { generateUrl } from '~utils/navigation/generateUrl'
import { Routes } from '~constants/routes'

export const processWithdraw = (data: Transaction): ProcessedNotificationData | null => {
    /**
     * Data subtype usage:
     * UNCLASSIFIED: swap flow, no need to show withdraw notification
     * BLOCKCHAIN: send on chain
     * OFFCHAIN: internal send to broker user without chain tx
     * SUB_ACCOUNT: send to sub account
     * FIAT: send fiat
     */

    if (data.subtype === 'UNCLASSIFIED') {
        return null
    }

    /**
     * Currently only success and failed statuses processed
     * Pending and created statuses are processed as "pending" one-time notification triggered on REST request
     */
    if (data.status === 'SUCCESS') {
        const { amount, currency } = data?.native || {}

        return {
            icon: <TxNotificationIcon status="SUCCESS" />,
            title: <FormattedHTMLMessage {...lang.successTitle} />,
            content: <AmountContent title={lang.successContent} amount={amount || '0'} currencyCode={currency || ''} />,
            status: 'success',
            dataPointer: 'withdraw_success_notification',
        }
    }

    if (data.status === 'FAILED') {
        return getErrorNotification({
            title: lang.errorTitle,
            content: lang.errorContent,
            buttonLink: generateUrl({ route: Routes.send }),
            buttonText: lang.errorButton,
            dataPointer: 'withdraw_failed_notification',
        })
    }

    return null
}
